import React from 'react';

import styled from 'styled-components';

import Avatar from 'common/Avatar';

import { ACTOR_TYPE } from '../../constants';

const Container = styled.div`
  display: flex;
  align-items: center;
`;

const UnassignedContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const StyledAvatar = styled(Avatar)`
  margin-right: 10px;
`;

const AssignToMe = styled.span`
  color: var(--dark-blue);
  font-size: 12px;
  user-select: none;
  cursor: pointer;
`;

type Props = {
  name: string | null | undefined;
  avatarUrl?: string | null;
  unassignedLabel?: string;
  showAssignToMe?: boolean;
  onAssignToMe?: (event: React.MouseEvent) => void;
};

const OwnerInfo = ({
  name,
  avatarUrl,
  unassignedLabel = 'Unassigned',
  showAssignToMe = false,
  onAssignToMe,
}: Props) => {
  if (!name) {
    return (
      <UnassignedContainer data-test-id="action-plans-owner-info-unassigned">
        <span data-test-id="action-plans-owner-info-unassigned-label">{unassignedLabel}</span>
        {showAssignToMe && (
          <AssignToMe data-test-id="action-plans-owner-info-assign-to-me" onClick={onAssignToMe}>
            Assign to me
          </AssignToMe>
        )}
      </UnassignedContainer>
    );
  }

  return (
    <Container data-test-id="action-plans-owner-info-assigned">
      <StyledAvatar
        size={30}
        type={ACTOR_TYPE.USER}
        name={name}
        src={avatarUrl || undefined}
        color="var(--negative-orange)"
      />
      <span data-test-id="action-plans-owner-info-name">{name}</span>
    </Container>
  );
};

export default OwnerInfo;
